import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getValidatedLimit} from "../../components/Utility";
import {getFormData} from "../../models/transactionModel";
import {fetchTransactionById, updateTransaction} from "../../store/transaction-slice";
import {transactionSchema} from "../../schema/transactionScehma";
import {fetchNotApplicableList} from "../../store/list-slice";

const TransactionEdit = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.transaction);
    const {limit, currentPage} = getValidatedLimit(pagination);
    const list = useSelector(state => state.list);

    const {
        items,
        updateStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.transaction);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchNotApplicableList())
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchTransactionById({...userRole, id: params.transactionId}));
    }, [dispatch, params.transactionId, userRole]);

    const transaction = items.find(item => item.id === params.transactionId);

    useEffect(() => {
        if (updateStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`);
        }
    }, [updateStatus, dispatch, navigator, currentPage, limit]);

    const formSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            amount: Number(data.amount),
        }
        dispatch(updateTransaction({...userRole, data: updatedData, id: params.transactionId}));
    }

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`);
    }

    const initialData = getFormData(transaction)
    const schema = transactionSchema({list});

    return (
        <>
            <SubHeader title="Update Transaction">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form onFormSubmit={formSubmitHandler}
                                  onFormCancel={formCancelHandler}
                                  schema={schema}
                                  inline={false}
                                  initialData={initialData}
                                  status={updateStatus}
                                  error={error}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )

}

export default TransactionEdit